export const lushootSingles: Record<string, string> = {
  e: "ə",
  j: "ǰ",
  D: "dᶻ",
  G: "gʷ",
  M: "m̓",
  N: "n̓",
  P: "p̓",
  S: "š",
  T: "t̓",
  Y: "y̓",
  Z: "ᶻ",
  "?": "ʔ",
  "`": "\u0313",
};

export const lushootMulti: Record<string, string[]> = {
  C: ["c̓", "č", "č̓"],
  K: ["k̓", "kʷ", "k̓ʷ"],
  L: ["l̓", "ɬ", "ƛ̕"],
  Q: ["q̓", "qʷ", "q̓ʷ"],
  W: ["w̓", "ʷ"],
  X: ["xʷ", "x̌", "x̌ʷ"],
};

export const lushootLetterNames: Record<string, string> = {
  "ʔ": "glottal stop",
  "a": "a",
  "b": "b",
  "c": "c",
  "c̓": "glottalized c",
  "č": "c wedge",
  "č̓": "glottalized c wedge",
  "d": "d",
  "dᶻ": "d raised z",
  "ə": "schwa",
  "g": "g",
  "gʷ": "g raised w",
  "h": "h",
  "i": "i",
  "ǰ": "j wedge",
  "k": "k",
  "k̓": "glottalized k",
  "kʷ": "k raised w",
  "k̓ʷ": "glottalized k raised w",
  "l": "l",
  "l̓": "glottalized l",
  "ɬ": "belted l",
  "ƛ̕": "glottalized barred lambda",
  "m": "m",
  "m̓": "glottalized m",
  "n̓": "glottalized n",
  "p": "p",
  "p̓": "glottalized p",
  "q": "q",
  "q̓": "glottalized q",
  "qʷ": "q raised w",
  "q̓ʷ": "glottalized q raised w",
  "s": "s",
  "š": "s wedge",
  "t": "t",
  "t̓": "glottalized t",
  "u": "u",
  "w": "w",
  "w̓": "glottalized w",
  "xʷ": "x raised w",
  "x̌": "x wedge",
  "x̌ʷ": "x wedge raised w",
  "y": "y",
  "y̓": "glottalized y",

  "\u0313": "glottalized",
  "ʷ": "raised w",
  "ᶻ": "raised z",
}
